import React, { Component } from 'react';

export function bidFormatter(cell) {
  if (cell) {
    return `&yen; ${Math.round(cell)}`;
  } else {
    return '';
  }
}

class StatusFormatter extends Component {
  render() {
    const {status} = this.props;
    switch(status.toUpperCase()) {
      case 'ACTIVE':
        return <span className="badge badge-primary">ACTIVE</span>;
      case 'ENABLED':
        return <span className="badge badge-success">ENABLED</span>;
      case 'PAUSED':
        return <span className="badge badge-warning">PAUSED</span>;
      case 'DISABLED':
        return <span className="badge badge-danger">DISABLED</span>;
      case 'UNDETERMINED':
        return <span className="badge badge-default">UNDETERMINED</span>;
      case 'ENDED':
        return <span className="badge badge-default">ENDED</span>;
      case 'OTHER':
        return <span className="badge badge-danger">OTHER</span>;
      case 'PENDING':
        return <span className="badge badge-warning">PENDING</span>;
      case 'RUNNING':
        return <span className="badge badge-primary">RUNNING</span>;
      case 'REMOVED':
        return <span className="badge badge-danger">REMOVED</span>;
      case 'INVALID':
        return <span className="badge badge-danger">INVALID</span>;
      default:
        return <p>{status}</p>
    }
  }
}

export function statusFormatter(cell) {
  if (cell !== undefined) {
    return <StatusFormatter status={cell} />
  } else {
    return '';
  }
}

class PublisherFormatter extends Component {
  render() {
    const {publisher} = this.props;

    switch(publisher) {
      case 'Google':
        return <i className="fa fa-google" style={{color: 'red'}} />;
      case 'Yahoo':
        return <i className="fa fa-yahoo" style={{color: 'purple'}}/>;
      case 'Facebook':
        return <i className="fa fa-facebook" style={{color: 'blue'}}/>;
      case 'Youtube':
        return <i className="fa fa-youtube"/>;
      default:
        return <p>{publisher}</p>
    }
  }
}

export function publisherFormatter(cell) {
  if (cell !== undefined) {
    return <PublisherFormatter publisher={cell} />
  } else {
    return '';
  }
}

export function dateFormatter(cell) {
  if (cell) {
    return new Date(cell).toLocaleDateString();
  } else {
    return '';
  }
}

export function costFormatter(cell) {
  if (cell !== undefined) {
    return `&yen; ${Math.round(cell)}`;
  } else {
    return '';
  }
}

class LinkFormatter extends Component {
  render() {
    const {id} = this.props;
    return <a className="nav-link" href={`#/settings?mcId=${id}`}>{id}</a>;
  }
}

export function linkFormatter(cell) {
  if (cell !== undefined) {
    return <LinkFormatter id={cell} />;
  } else {
    return '';
  }
}

class CheckFormatter extends Component {
  render() {
    const {cell} = this.props;

    if (parseInt(cell) === 1) {
      return <i className="fa fa-check-circle bg-success"/>
    } else {
      return <i className="fa fa-close bg-danger"/>
    }
  }
}

export function checkFormatter(cell) {
  if (cell !== undefined) {
    return <CheckFormatter cell={cell}/>
  } else {
    return '';
  }
}

export function percentageFormatter(cell) {
  if (cell && cell !== '') {
    return `${cell * 100} %`;
  } else {
    return '';
  }
}

export function adTypeFormatter(cell) {
  if (cell) {
    return (cell === 'TextAd') ?
      'Text' : (cell === 'ImageAd') ?
      'Image' : cell;
  } else {
    return '';
  }
}

class AdFormatter extends Component {
  render() {
    const {ad} = this.props;

    switch(ad.type) {
      case 'TextAd':
        return (
          <div>
            <span dangerouslySetInnerHTML={{__html: ad.content}} />
          </div>
        );
      case 'ImageAd':
      case 'IMAGE':
        return (
          <div style={{maxHeight: '100px', margin: '10px', overflow:'hidden' }}>
            <a href={ad.content} target="_blank" >
              <img src={ad.content} alt={ad.content}/>
            </a>
          </div>
        );
      default:
        return <span dangerouslySetInnerHTML={{__html: ad.content}} />;
    }
  }
}

export function adFormatter(cell) {
  if (cell) {
    return (
      <AdFormatter ad={cell} />
    )
  } else {
    return '';
  }
}

class AdNameFormatter extends Component {
  render() {
    const {name} = this.props;
    return (
      <div>
        <p>{name.Campaign}</p>
        <p>{name.adGroup}</p>
        <p>{name.Ad_Name}</p>
        <p><a href={`http://${name.display_url}`} target="_blank">{name.display_url}</a></p>
      </div>
    );
  }
}

export function adNameFormatter(cell) {
  if (cell) {
    return (
      <AdNameFormatter name={cell} />
    )
  } else {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/views/Formatter/index.js